<app-wa-table
  [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="false"
  [areMoreData]="false" (loadMore)="loadMore()" [data]="matches" (headerClick)="changeSort($event)"
>

    <ng-template [extraClass]="['nowrap','wa-table__cell--fit-left' ]" app-column let-match >
        <ng-container *ngIf="getSelfAthlete as selfAthlete">
            <lib-athlete-photo [isTeam]="true" [id]="selfAthlete.NOC"></lib-athlete-photo>
         </ng-container>
    </ng-template>
    <ng-template [extraClass]="['nowrap','wa-table__cell--fit-left' ]" app-column let-match >
        <ng-container *ngIf="getSelfAthlete as selfAthlete">
            <div class="inline uppertext-black-no-viewport">{{selfAthlete.CountryShort}}</div>
         </ng-container>
    </ng-template>
    <ng-template [extraClass]="['nowrap','wa-table__cell--fit-left']" app-column let-match >
        <ng-container>
            <lib-athlete-photo [isTeam]="true" [id]="match.Athlete.NOC"></lib-athlete-photo>
          </ng-container>
    </ng-template>
    <ng-template [extraClass]="['wa-table__cell', 'td-26']" app-column let-match >
        <ng-container>
            <div class="inline uppertext-black-no-viewport">{{match.Athlete.Name}}</div>
          </ng-container>
    </ng-template>
    <ng-template [extraClass]="['nowrap','wa-table__cell--fit']" app-column let-match >
      <ng-container>
          <div style="vertical-align: sub;" class="inline uppertext-no-viewport">{{match.PhaseName}}</div>
        </ng-container>
  </ng-template>
    <ng-template [extraClass]="['nowrap','wa-table__cell--fit' ]" app-column let-match >
        <ng-container>

            <app-win-loss-event [winLoss]="match.WinLose" [selfPoints]="match.Score" [otherPoints]="match.ScoreOpponent"></app-win-loss-event>

          </ng-container>
    </ng-template>
    <ng-template [extraClass]="['nowrap','wa-table__cell--fit-right']" app-column let-match >
        <ng-container>

            <span style="margin-left:14px" (click)="selectIndex(match.index)" class="plus-minus {{isIndexSelected(match.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}"></span>

          </ng-container>
    </ng-template>
    <ng-template [extraClass]="['','wa-table__cell--fit']" app-column-responsive let-match>
      <div class="view-flags">
          <div *ngIf="getSelfAthlete as selfAthlete">
              <lib-athlete-photo [isTeam]="true" [id]="selfAthlete.NOC"></lib-athlete-photo>
              <div class="inline uppertext-black-no-viewport">{{selfAthlete.CountryShort}}</div>
           </div>
      </div>
    </ng-template>
    <ng-template [extraClass]="['','wa-table__cell--fit']" app-column-responsive let-match>
        <div class="view-flags">
             <div>
                <lib-athlete-photo [isTeam]="true" [id]="match.Athlete.NOC"></lib-athlete-photo>
                <div class="inline uppertext-black-no-viewport">{{match.Athlete.Name}}</div>

              </div>
        </div>
      </ng-template>
<ng-template [extraClass]="['visibility--hide-desktop', 'expand-row']" app-row-group let-match>
    <div class="access-bar-mobile">
        <ng-container>

            <app-win-loss-event  [winLoss]="match.WinLose" [selfPoints]="match.Score" [otherPoints]="match.ScoreOpponent"></app-win-loss-event>

          </ng-container>
          <ng-container>
            <div style="vertical-align: sub;" class="inline uppertext-no-viewport">{{match.PhaseName}}</div>
          </ng-container>
          <ng-container>

              <span (click)="selectIndex(match.index)" class="plus-minus {{isIndexSelected(match.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}"></span>

            </ng-container>
    </div>
</ng-template>
<ng-template [extraClass]="[]" app-row let-match>
    <td colspan="100%" class="wa-table__cell--fit no-width">
      <div [@slideInOut]="animationDetailState" *ngIf="isIndexSelected(match.index) === true" class="wa-table-details">
      <div class="content-team" style="text-align: right">
        <div class="uppertext-black-no-viewport space">
            <div *ngIf="getSelfAthlete as athlete">
                <div class="uppertext-black-no-viewport">{{athlete.CountryShort}}</div>
                <lib-country-flag [id]="athlete.NOC"></lib-country-flag>
            </div>
        </div>
        <tr style="text-align: right" class="nowrap" *ngFor="let member of members">
            <lib-athlete-name style="width:150px" [id]="member.Id" [wnameord]="member.WNameOrd" [gname]="member.GName" [fname]="member.FName"></lib-athlete-name>
            <lib-athlete-photo [isTeam]="false" [id]="member.Id"></lib-athlete-photo>
        </tr>
      </div>
      <div class="content-team"  style="text-align: left">
          <div class="uppertext-black-no-viewport space">
            <div *ngIf="getSelfAthlete as athlete">
                <lib-country-flag [id]="match.Athlete.NOC"></lib-country-flag>
              <div class="uppertext-black-no-viewport">{{match.Athlete.Name}}</div>
            </div>

          </div>

          <tr *ngFor="let member of match.Athlete.Members">
              <lib-athlete-photo [isTeam]="false" [id]="member.Id"></lib-athlete-photo>
              <lib-athlete-name style="margin-left:10px"  [id]="member.Id" [wnameord]="member.WNameOrd" [gname]="member.GName" [fname]="member.FName"></lib-athlete-name>
          </tr>
        </div>
      </div>
    </td>
  </ng-template>

    <!--
    <div *ngFor="let match of result.Matches; let i=index">
    <div style="display:flex">
      <div style="margin-right:+60px;margin-top:-9px;"  class="icon">
          <ng-container>

            <app-win-loss-event [winLoss]="match.WinLose" [selfPoints]="match.Score" [otherPoints]="match.ScoreOpponent"></app-win-loss-event>

          </ng-container>
        </div>
        <span (click)="clickOnTeam(i)" class="plus-minus {{isTeamSelected(i,result.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}"></span>
      </div>
    </lib-athlete-photo>
    <div *ngIf="isTeamSelected(i, result.index) === true" class="members-block">
      <table>
        <td>
          <tbody *ngIf="getSelfAthlete as athlete" >
            <th class="align-right">
              <div class="team-flag-name">
                  <div class="uppertext-black">{{athlete.CountryShort}}</div>
                  <lib-country-flag [id]="athlete.NOC"></lib-country-flag>
                </div>

            </th>
        <tr *ngFor="let member of result.Members">
          <lib-athlete-name [id]="member.Id" [wnameord]="member.WNameOrd" [gname]="member.GName" [fname]="member.FName"></lib-athlete-name>
          <lib-athlete-photo [isTeam]="false" [id]="member.Id"></lib-athlete-photo>
        </tr>
      </tbody>
        </td>
        <td>
          <tbody>
              <th class="align-left">
                  <ng-container>
                      <div class="team-flag-name">

                      <lib-country-flag [id]="match.Athlete.NOC"></lib-country-flag>
                      <div class="uppertext-black">{{match.Athlete.Name}}</div>
                      </div>
                    </ng-container>
              </th>
            <tr *ngFor="let member of match.Athlete.Members">
              <lib-athlete-photo [isTeam]="false" [id]="member.Id"></lib-athlete-photo>
              <lib-athlete-name [id]="member.Id" [wnameord]="member.WNameOrd" [gname]="member.GName" [fname]="member.FName"></lib-athlete-name>

            </tr>
          </tbody>
            </td>
      </table>
      </div>
      </div>
  </div>
  -->
</app-wa-table>
